import React from "react";
import PropTypes from "prop-types";
import ChatBubbleOutline from "@mui/icons-material/ChatBubbleOutline";
import Close from "@mui/icons-material/Close";
//Limitless imports
import { ClientContext } from "@limitless/common/utils";
import { useMobileDetectionContext } from "hooks/mobile-detection/MobileDetectionContext";
import { CustomerFabButton } from "@limitless/customer/components";
import { useAppVisibilityContext } from "../../hooks/app-visibility/AppVisibilityContext";

const CLOSE_ICON_MAP = {
    chat: ChatBubbleOutline,
    close: Close
};

const Fab = ({ isLLMVisible, isMobileDevice, onClick, unReadMessage }) => {
    const {
        appVisibility: { isAppOpen }
    } = useAppVisibilityContext();

    const { getCustomOffsetStyles } = useMobileDetectionContext();
    const CloseIcon = CLOSE_ICON_MAP[ClientContext._fabCloseButtonStyle];

    return (
        <CustomerFabButton
            isLLMVisible={isLLMVisible}
            isMobileDevice={isMobileDevice}
            onClick={onClick}
            unReadMessage={unReadMessage}
            getCustomOffsetStyles={getCustomOffsetStyles}
            isAppOpen={isAppOpen}
            animation={ClientContext._animation}
            fabMobileText={ClientContext._fabMobileText}
            clientContextFabText={ClientContext._fabText}
            fabButtonStyle={ClientContext._fabButtonStyle}
            expandableFab={ClientContext._expandableFab}
            rightOffset={ClientContext._rightOffset}
            bottomOffset={ClientContext._bottomOffset}
            CloseIcon={CloseIcon}
        />
    );
};

export default Fab;

Fab.propTypes = {
    isLLMVisible: PropTypes.bool.isRequired,
    isMobileDevice: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    unReadMessage: PropTypes.bool.isRequired
};
